<template>

	<app-boards board-key="news_feeds"></app-boards>

</template>

<script>
import AppBoards from "@/components/boards/appBoards";
export default {
	name: "newsfeeds",
	components: {AppBoards}
}
</script>

<style scoped>

</style>